/**
 * Practical crypto-tax pipeline defaults (Finland-oriented, FIFO in `fifo.ts`).
 * Tune here as you add Excel, more chains, or explorer chunking.
 */
export const TAX_PIPELINE = {
  /** Future: split explorer requests into N-day block windows (needs block↔time mapping). */
  explorerChunkDays: 30,
  /** Cronos ~5.5s block time — used when we add block-window fetches. */
  cronosAvgBlockTimeSec: 5.5,
  /** When no EUR quote exists, FIFO already assumes 0 cost on shortfalls; Cronos rows stay visible with null EUR until priced. */
  defaultMissingCostBasisEur: 0,
  /**
   * Finnish export / classification defaults.
   * - `balanced`: internal platform moves default to non-taxable (no FIFO consumption); ambiguous → review.
   * - `conservative`: legacy Crypto.com “move” rows treated as disposal/acquisition at FMV where implemented.
   */
  fi: {
    policyMode: 'balanced' as 'balanced' | 'conservative',
    /**
     * Filing: `best` = min(fifo_gain, deemed_gain); deemed uses 20%/40% of proceeds (holding bracket). Set here only.
     */
    basisMethod: 'best' as 'fifo' | 'deemed' | 'best',
    timezone: 'UTC' as 'UTC' | 'Europe/Helsinki',
  },
} as const;
